import { Common } from '@stockbit/ui';
import { FooterIcon, IconFooterWrapper } from './styled';

const { IconWrapper } = Common;

interface IconFooterProps {
  isVisible?:boolean;
  title: string;
  src: string;
  alt: string;
  onClick?: any;
  iconRef?: any;
}

function IconFooter({ isVisible = true, src, alt, onClick, title, iconRef }: IconFooterProps) {
  if (isVisible) {
    return (
      <IconFooterWrapper onClick={onClick} title={title} ref={iconRef}>
        <IconWrapper>
          <FooterIcon src={src} alt={alt} />
        </IconWrapper>
      </IconFooterWrapper>
    );
  }
  return null;
}

export default IconFooter;
